module.exports = __webpack_public_path__ + "static/media/auto-placeholder.a3cdfe30.webp";